.container {
	display: flex;
	flex-direction: column;
	overflow-y: auto;
	position: relative;
	background-color: var(--mantine-color-white);
	scroll-behavior: smooth;
	margin-left: var(--mantine-spacing-md);
	margin-top: var(--mantine-spacing-md);
	scrollbar-gutter: stable;
	box-shadow: 0 10px 40px var(--mantine-color-gray-2);

	@include screen-sm {
		margin-left: 0;
		margin-top: 0;
		padding: 0 !important;
		padding-inline: 0 !important;
	}

	.title {
		@include screen-sm {
			position: sticky;
			top: 0;
			background: var(--mantine-color-gray-1);
			z-index: 100;
		}
	}
}
